import React from 'react'

import { DropdownLink } from 'assets/styles/dropdown'
import TrackedDropdownLink from 'components/TrackedDropdownLink/TrackedDropdownLink'
import hasPermission from 'state/user/userPermissions'
import { User, UserPermissions } from 'state/user/UserState'

interface AccountDropdownMenuProps {
    user: User
    onLogout: () => void
}

export default function AccountDropdownMenu({
    user,
    onLogout,
}: Readonly<AccountDropdownMenuProps>): JSX.Element {
    return (
        <>
            <TrackedDropdownLink
                testId="myaccount-link"
                text="Account Settings"
                hashNavigate="account-settings"
            />
            {hasPermission(
                user,
                UserPermissions.CAN_VIEW_DEALERSHIP_SETTINGS,
            ) && (
                <TrackedDropdownLink
                    testId="mydealership-link"
                    text="Dealership Settings"
                    hashNavigate="dealership-settings"
                />
            )}
            <DropdownLink data-testid="logout-link" onClick={onLogout}>
                Log Out
            </DropdownLink>
        </>
    )
}
